import React, { FC } from "react";
import { connect } from "react-redux";

import cn from "classnames";
import { defineMessages, useIntl } from "react-intl";

import { getOrganizationName } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import styles from "./LabelCommon.module.scss";

const messages = defineMessages({
  entireOrganization: {
    id: "dashboard.sidebar.entireOrganization",
    defaultMessage: "Entire Organization",
    description: "Entire Organization label in Dashboard sidebar when org name is not available",
  },
});

interface Props {
  organizationName?: string;
}

const OrganizationLabel: FC<Props> = ({ organizationName }) => {
  const intl = useIntl();

  return (
    <div className={cn(styles.container, styles.organization)}>
      {organizationName ?? intl.formatMessage(messages.entireOrganization)}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  organizationName: getOrganizationName(state),
});

export default connect(mapStateToProps)(OrganizationLabel);
